import { cloneDeep, sortBy } from "lodash";

import {
  CreateOnsiteInjectionDto,
  CreateShippingRateGroupDto,
  CreateVariationDto,
  OfferDto,
  OnsiteEditDto,
  OnsiteInjectionDto,
  ShippingRateGroupDto,
  ShippingRateGroupFe,
  VariationDto,
} from "@intelligems/ig-types";
import { RounderObject } from "@intelligems/ig-utils";

import {
  VariationFe,
  VariationFeProps,
} from "../../../../types/schemas/variations";
import { genericSort } from "../../../../utils/sortings";
import { initialFrontendProps } from "../../../initials";

export const getVariationDtoFromFe = (
  variations: VariationFe[]
): CreateVariationDto[] => {
  const isCustomTest = variations.some((group: VariationFe) =>
    group.shippingRateGroups!.some(
      (rateGroup) => rateGroup.groupType === "custom"
    )
  );
  return variations.map((variation) => {
    // const foundOffer: OfferDto | undefined = offers.find(
    //   (offer) => offer.id === variation.offerId
    // );
    // const foundOnsiteEdits: OnsiteEditDto[] = onsiteEdits.filter(
    //   (edit) => edit.variationId === variation.id
    // );
    // const foundInjection: CreateOnsiteInjectionDto | undefined =
    //   onsiteInjections.find(
    //     (injection) => injection.variationId === variation.id
    //   );
    return {
      id: variation.id,
      experienceId: variation.experienceId,
      name: variation.name,
      percentage: variation.percentage,
      isControl: variation.isControl,
      order: variation.order,
      priceChangeUnit: variation.priceChangeUnit,
      priceChange: variation.priceChange,

      // onsiteEdits: foundOnsiteEdits,
      // onsiteInjections: foundInjection ?? undefined,
      // offer: fv,
      shippingRateGroups: getShippingRateGroupsDtoFromFe(
        isCustomTest,
        variation
      ),
      excludeProducts: variation.excludeProducts,
      includeProducts: variation.includeProducts,
      testExperienceId: variation.testExperienceId,
      functionSyncError: variation.functionSyncError,
    };
  });
};

const getShippingRateGroupsDtoFromFe = (
  isCustomTest: boolean,
  group: VariationFe
): CreateShippingRateGroupDto[] => {
  if (!isCustomTest) {
    return group.shippingRateGroups!.map((group) => ({
      ...group,
      rates: group.rates.map((rate) => ({
        ...rate,
        amount: rate.amount || 0,
        condition: rate.condition
          ? {
              id: rate.condition.id,
              min: rate.condition.min || 0,
              max: rate.condition.max,
              conditionType: rate.condition.conditionType,
              unit: rate.condition.unit,
            }
          : undefined,
      })),
    }));
  } else {
    const isGroupWithCustom = group.shippingRateGroups!.some(
      (rateGroup) => rateGroup.groupType === "custom"
    );
    if (!isGroupWithCustom) {
      return [];
    } else {
      return group.shippingRateGroups!.map((group) => ({
        ...group,
        rates: [],
      }));
    }
  }
};

export const ensureShippingRateGroups = (
  variation: VariationDto
): ShippingRateGroupFe[] => {
  if ((variation.shippingRateGroups || []).length > 0) {
    return cloneDeep(variation.shippingRateGroups)!.sort((a, b) =>
      genericSort(a, b, "position")
    );
  }
  return [];
};
export const getVariationFeFromDto = (
  variations: VariationDto[]
): VariationFe[] => {
  return sortBy(
    variations.map((variation) => {
      const shippingRateGroups = ensureShippingRateGroups(variation);
      const frontendProps = ensureFrontendProps(variation, variations.length);
      const ret: VariationFe = {
        ...variation,
        ...frontendProps,
        shippingRateGroups,
      };
      return ret;
    }),
    (_) => _.order
  );
};

export const ensureFrontendProps = (
  variation: VariationDto,
  variationsLength: number
): VariationFeProps => {
  return initialFrontendProps({
    name: variation.name,
    percentage: variation.percentage,
    order: variation.order,
    priceChange: variation.priceChange,
    count: variationsLength,
    useWideApp: false,
  });
};

export const isZero = (group: RounderObject, deltaX: any) => {
  return group.percentage <= 0 || group.percentage - Math.abs(deltaX / 10) < 0;
};

export const getDragDirection = (
  index: number,
  group: RounderObject,
  groupIndex: number
) => {
  if (index === groupIndex && group.percentage >= 0) {
    return "subtract";
  } else if (index === groupIndex - 1 && group.percentage <= 100) {
    return "add";
  }
};

export const getTempVariations = (
  variations: VariationFe[],
  groupIndex: number,
  deltaX: number,
  sliderWidth: number
) => {
  return variations.map((group: VariationFe, index: number) => {
    const direction = getDragDirection(index, group, groupIndex);

    if (direction) {
      const newWidth =
        direction === "add" ? group.width + deltaX : group.width - deltaX;
      if (newWidth > 1000) {
        return group;
      } else if (newWidth < 0) {
        return {
          ...group,
          percentage: 0,
          width: 0,
        };
      } else {
        return {
          ...group,
          percentage: (newWidth / sliderWidth) * 100,
          width: newWidth,
        };
      }
    } else {
      return group;
    }
  });
};
